import { forwardRef } from "react";

import { Input } from "@/components/ui/input";
import { cn } from "@/utils/cn";

interface PriceInputProps extends Omit<React.ComponentProps<"input">, "type"> {
  errorText?: string;
}

/**
 * docs/ui/component-inventory.md's `PriceInput`: a currency-aware numeric
 * field. BazaarX is INR-first (docs/ui/component-inventory.md's `Currency`
 * primitive defaults to `en-IN`/`INR`), so `₹` is a fixed prefix, not a
 * configurable `currencySymbol` prop — nothing in this codebase renders a
 * price in any other currency yet.
 */
export const PriceInput = forwardRef<HTMLInputElement, PriceInputProps>(
  ({ className, errorText, ...props }, ref) => {
    return (
      <div className="relative">
        <span
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-body text-muted-foreground"
          aria-hidden="true"
        >
          ₹
        </span>
        <Input
          ref={ref}
          type="number"
          inputMode="numeric"
          min={0}
          step="1"
          className={cn("pl-7", className)}
          aria-invalid={Boolean(errorText)}
          {...props}
        />
      </div>
    );
  },
);
PriceInput.displayName = "PriceInput";
